import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

class ExpanderComponent extends Component {
  init() {
    this.button = this.element.querySelector('.expander__button')
    this.region = this.element.querySelector('.expander__content-container')

    if (!this.button || !this.region) {
      return
    }

    this.button.addEventListener('click', () => this.toggleRegion())
  }

  toggleRegion() {
    if (!this.button || !this.region) {
      return
    }

    if (this.button.getAttribute('aria-expanded') === 'true') {
      this.region.setAttribute('hidden', 'hidden')
      this.region.setAttribute('inert', 'inert')
      this.button.setAttribute('aria-expanded', false)
      this.element.classList.remove('expander--expanded')
    } else {
      this.region.removeAttribute('hidden')
      this.region.removeAttribute('inert')
      this.button.setAttribute('aria-expanded', true)
      this.element.classList.add('expander--expanded')
    }
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'expander', ExpanderComponent))
